import { render, staticRenderFns } from "./PaginationPanel.vue?vue&type=template&id=162f0f0e&scoped=true"
import script from "./PaginationPanel.vue?vue&type=script&lang=js"
export * from "./PaginationPanel.vue?vue&type=script&lang=js"
import style0 from "./PaginationPanel.vue?vue&type=style&index=0&id=162f0f0e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162f0f0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_acadmin_online_docker/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('162f0f0e')) {
      api.createRecord('162f0f0e', component.options)
    } else {
      api.reload('162f0f0e', component.options)
    }
    module.hot.accept("./PaginationPanel.vue?vue&type=template&id=162f0f0e&scoped=true", function () {
      api.rerender('162f0f0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/PaginationPanel.vue"
export default component.exports